<template>
  <div v-if="token.role === 'ADM' || token.role === 'CA'">
    <div class="row mt-5" v-if="token.role === 'ADM'">
      <div class="col text-center">
        <h5>Usuários</h5>
      </div>
    </div>
    <hr>
    <div class="row"  v-if="!token.somenteLeitura">
      <div class="col">
        <router-link tag="button" :disabled="total >= maxUser" :to="`${route}/novo`" class="btn btn-block btn-primary btn-raised">
          + Adicionar um novo usuário
        </router-link>
        <button data-toggle="modal" data-target="#planoModal" v-if="total >= maxUser" class="btn btn-block btn-warning btn-raised" type="button">
          Fazer upgrade de plano agora?
        </button>
        <hr>
      </div>
    </div>

    <div class="modal fade" id="planoModal" tabindex="-1" role="dialog" aria-labelledby="planoModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Selecione um Plano para atualizar<br>
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

              <form action="">
                 <div class="form-group">
                    <label for="email">Plano</label>
                    <select class="form-control" name="plano" id="plano" v-model="modal.plano">
                      <option v-for="plano in planos" :key="plano._id" :value="plano._id">{{plano.nome}}</option>
                    </select>
                  </div>
              </form>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success btn-raised mr-2" @click="updatePlano()">Atualizar Plano</button>
              <button type="button" class="btn btn-danger btn-raised" data-dismiss="modal">Não atualizar</button>
            </div>
          </div>
        </div>
      </div>

    <div class="row">
      <div class="col">
          <div class="alert alert-warning" role="alert" v-if="data.length === 0">
            Nenhum registro cadastrado.
          </div>

          <form v-on:submit.prevent="setPage(1)" v-if="token.role === 'CA' || token.role === 'ADM'">
            <fieldset>
            <legend>Filtrar</legend>
            <div class="form-group">
              <label for="filtro">Nome</label>
              <input v-model="filtro" id="filtro" type="text" class="form-control">
            </div>

            <div class="form-group" v-if="token.role === 'ADM'">
              <label for="empresa">Empresa</label>
              <select @change="setPage(1)" v-model="empresa" class="form-control" name="empresa" id="empresa">
                <option value="TODAS">TODAS</option>

                <option v-for="empresa in empresas" :key="empresa._id" :value="empresa._id">{{empresa.nome}}</option>
              </select>
            </div>
            </fieldset>
          </form>

          <table class="table table-sm">
            <thead class="thead-light">
              <tr>
                <th scope="col">Login / Nome</th>
                <th scope="col">Logou</th>
                <th scope="col">Opções</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="item in data" :key="item._id">
                  <td scope="row"><b>{{item.login}}</b> - {{item.nome}}</td>

                  <td>
                    {{item.logins}}x
                  </td>
                  <td  v-if="!token.somenteLeitura">
                    <router-link class="btn btn-raised btn-warning btn-sm" title="Edit" :to="`${route}/edit/${item._id}`">
                      Alterar
                    </router-link>
                    <a class="btn btn-raised btn-danger btn-sm"  href="javascript:;" @click.prevent="remove(item._id)" title="Remove">Remover</a>
                  </td>
                </tr>
              </tbody>
          </table>
      </div>
    </div>

    <hr>
    <div class="row" v-if="data.length > 0">
      <div class="col">
          <pagination :records="total" :options='pagOpts' :per-page="perPage" @paginate="setPage">
          </pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';
import vueDropzone from 'vue2-dropzone';

export default {
  components: {
    vueDropzone
  },
  data() {
    return {
      data: [],
      planos: [],
      empresas: [],
      filtro: '',
      empresa: 'TODAS',
      route: '/admin/usuarios',
      page: 1,
      perPage: 10,
      total: 0,
      maxUser: 99999999,
      pagOpts: this.$custom.pagOpts,
      form: {
        numeroProtocolo: '',
        data: moment().format('YYYY-MM-DD'),
        documento: '',
        _id: ''
      },
      modal: {
        plano: ''
      },
      dropzoneOptions: this.$http.getDropzoneConfig(`/usuario/upload`, 'post', {
        maxFiles: 1,
        addRemoveLinks: true,
        capture: true,
        dictDefaultMessage: 'Clique ou arraste arquivos aqui para UPLOAD',
        dictRemoveFile: 'Remover'
      })
    };
  },
  methods: {
    remove(id) {
      if (confirm('Tem certeza que deseja excluir este usuário?')) {
        this.$http.delete(`usuario/${id}`).then(() => {
          this.setPage(this.page);
        });
      }
    },
    setPage: function(page) {
      this.page = page;

      const skip = (page - 1) * this.perPage;
      const limit = this.perPage;
      const filtro = this.filtro;
      const empresa = this.empresa;

      let url = `usuario/list`;

      this.$http.post(url, { skip, limit, filtro, empresa }).then(response => {
        this.data = response.data.data;
        this.total = response.data.total;
        this.maxUser = response.data.maxUser;

        if (this.total > 0 && this.data.length === 0 && this.page > 1) {
          this.page -= 1;
          this.setPage(this.page);
        }
      });

      if (this.token.role === 'CA') {
        this.$http.post('/admin/planos/list', { skip, limit }).then(response => {
          this.planos = response.data.data.map((p) => p);

          if (response.data.atual) {
            this.modal.plano = response.data.atual._id;
          }
        });
      }
    },
    updateDoc(file, response) {
      this.form.mimetype = response.mimetype;
      this.form.filename = response.filename;
      this.form.originalname = response.originalname;
    },
    updatePlano() {
      this.$http.post('/admin/planos/update', this.modal).then(response => {
        if (response.data.success) {
          this.$toasted.show('Plano atualizado com sucesso!', this.$custom.success);
          $('#planoModal').modal('hide');
          this.setPage(this.page);
        } else {
          this.$toasted.show('Ocorreu um erro!', this.$custom.error);
        }
      });
    }
  },
  beforeMount() {
    this.$http.post('/admin/empresas/list').then(response => {
        this.empresas = response.data.data;
    });

    this.setPage(1);
  }
};
</script>

<style scoped>
.id {
  font-size: 12px;
}

.card {
  cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// src/components/app/admin/usuarios/Home.vue